/**
 * Alert de-duplication.
 *
 * A green listing stays green on every poll until someone buys it, so without
 * this the same deal would beep every 30 seconds forever. Offers are keyed by
 * item + source + seller + price, which means a price *change* is treated as a
 * new deal — that is intentional, a re-listing at a lower price is news.
 */

import { ignored$ } from "../state/store.ts";

/** Keys alerted this session. Cleared on stop so a restart re-announces. */
const alerted = new Set<string>();

/** Keys the user dismissed; persisted, so they stay quiet across reloads. */
let ignoredSet = new Set<string>(ignored$.get());
ignored$.subscribe((keys) => {
  ignoredSet = new Set(keys);
}, false);

export function isIgnored(key: string): boolean {
  return ignoredSet.has(key);
}

export function ignoreOffer(key: string): void {
  if (ignoredSet.has(key)) return;
  ignored$.update((keys) => [...keys, key]);
}

export function unignoreOffer(key: string): void {
  ignored$.update((keys) => keys.filter((existing) => existing !== key));
}

export function clearIgnored(): void {
  ignored$.set([]);
}

export function ignoredCount(): number {
  return ignoredSet.size;
}

/** True the first time a key is seen; false on every repeat. */
export function claimAlert(key: string): boolean {
  if (alerted.has(key)) return false;
  alerted.add(key);
  return true;
}

export function resetAlerts(): void {
  alerted.clear();
}
